module.exports = __webpack_public_path__ + "img/collection-diamondJewelryExclusive@2x.9f54706.webp";